"use client"

import { useState } from "react"
import { Button } from "@/components/ui/button"
import { CheckCircle2, ChevronDown } from "lucide-react"
import { useTranslations } from "@/hooks/use-translations"

export function VerificationInfo() {
  const [showInfo, setShowInfo] = useState(false)
  const { t } = useTranslations()

  return (
    <div className="my-4">
      <Button
        variant="ghost"
        onClick={() => setShowInfo(!showInfo)}
        className="flex items-center gap-2 text-sm text-gray-600 hover:text-gray-800 p-0 h-auto font-normal"
      >
        <span>{t("areReviewsReliable")}</span>
        <ChevronDown className={`w-4 h-4 transition-transform ${showInfo ? "rotate-180" : ""}`} />
      </Button>

      {showInfo && (
        <div className="mt-3 p-4 bg-gray-50 rounded-lg border border-gray-300">
          <div className="space-y-3">
            <div className="flex items-start gap-3">
              <CheckCircle2 className="w-5 h-5 text-green-600 flex-shrink-0 mt-0.5" />
              <div>
                <h4 className="font-medium text-gray-900 mb-1">{t("verifiedReviews")}</h4>
                <p className="text-sm text-gray-600">{t("verifiedReviewsDescription")}</p>
              </div>
            </div>

            <div className="pl-8">
              <h5 className="font-medium text-gray-800 mb-2">{t("verificationProcess")}</h5>
              <ul className="text-sm text-gray-600 space-y-1">
                <li>• {t("telephoneVerification")}</li>
                <li>• {t("confirmationOfUse")}</li>
                <li>• {t("validationOfExperiences")}</li>
              </ul>
            </div>
          </div>
        </div>
      )}
    </div>
  )
}
